import { createZustandStore } from '../../../zustand';

import { ITransferState } from './type';

/**
 * This creates a local global state for Transfer list selected filters and update the
 * filters
 */
export const useTransferStore = createZustandStore<ITransferState>()((set) => ({
  selectedTransferFilter: null,
  updateSelectedTransferFilter: (selectedTransferFilter) =>
    set({ selectedTransferFilter }),
}));
